(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ntl-account-addresses"] && !Shopify.designMode) return;
  try {
    
/* COUNTRY → PROVINCE (§5.6: existence-guarded, delegated, never throws).
   Shopify only ships province data as a data-provinces attribute on each
   country <option>; there is no Liquid object for it. This reads that
   attribute, rebuilds the province <select>, and hides the field entirely for
   countries that have no provinces. Options are built with createElement so a
   province name can never be injected as markup. */
(function () {
  function fillProvinces(country) {
    if (!country) return;
    var form = country.form;
    if (!form) return;
    var prov = form.querySelector('[data-ntl-province]');
    var wrap = form.querySelector('[data-ntl-province-wrap]');
    if (!prov || !wrap) return;

    var opt = country.options[country.selectedIndex];
    var raw = opt ? opt.getAttribute('data-provinces') : null;
    var list = [];
    if (raw) {
      try { list = JSON.parse(raw); } catch (e) { list = []; }
    }

    wrap.setAttribute('data-ready', '');

    if (!list.length) {
      prov.innerHTML = '';
      prov.disabled = true;
      wrap.hidden = true;
      return;
    }

    var want = prov.getAttribute('data-default') || '';
    prov.disabled = false;
    prov.innerHTML = '';
    for (var i = 0; i < list.length; i++) {
      var row = list[i];
      if (!row || !row.length) continue;
      var o = document.createElement('option');
      o.value = row[0];
      o.textContent = row[1] != null ? row[1] : row[0];
      if (row[0] === want) o.selected = true;
      prov.appendChild(o);
    }
    wrap.hidden = false;
  }

  function initCountries(root) {
    var scope = root || document;
    var list;
    try { list = scope.querySelectorAll('.ntl-account-addresses [data-ntl-country]'); }
    catch (e) { return; }
    for (var i = 0; i < list.length; i++) {
      var c = list[i];
      var want = c.getAttribute('data-default');
      if (want) {
        for (var j = 0; j < c.options.length; j++) {
          if (c.options[j].value === want) { c.selectedIndex = j; break; }
        }
      }
      fillProvinces(c);
    }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.hasAttribute || !t.hasAttribute('data-ntl-country')) return;
    var prov = t.form && t.form.querySelector('[data-ntl-province]');
    if (prov) prov.setAttribute('data-default', '');
    fillProvinces(t);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCountries(); });
  } else {
    initCountries();
  }
  document.addEventListener('shopify:section:load', function (e) {
    initCountries(e.target || document);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ntl-account-login"] && !Shopify.designMode) return;
  try {
    
/* Open the "forgotten password" panel for a shopper arriving on a recover deep link
   (?recover=true or #recover). Liquid cannot read a query string, so this is the one
   piece that has to be JS. Fully guarded: a throw here must not take down any other
   section's JS in Shopify's shared bundle. */
(function () {
  try {
    var wants = /[?&]recover=true/.test(window.location.search) ||
                window.location.hash === '#recover';
    if (!wants) return;
    var dt = document.querySelector('.ntl-ac-dt-rec');
    if (!dt) return;
    dt.open = true;
    var input = dt.querySelector('input[type="email"]');
    if (input) { try { input.focus({ preventScroll: true }); } catch (e) {} }
  } catch (e) { /* never break the shared section bundle */ }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ntl-article-main"] && !Shopify.designMode) return;
  try {
    
/* NTL article — contents list, reading progress, share/copy.
   Everything is existence-guarded and wrapped: one throw here would kill every
   later section's JavaScript (§5.6). Nothing below hides content: the rail is
   navigation DERIVED from headings that are already rendered. */
(function () {
  'use strict';

  function build(root) {
    if (!root || root.getAttribute('data-ntl-art-ready') === '1') return;
    root.setAttribute('data-ntl-art-ready', '1');

    var body = root.querySelector('[data-ntl-abody]');
    var toc = root.querySelector('[data-ntl-atoc]');
    var bar = root.querySelector('[data-ntl-aprog]');
    var cols = root.querySelector('[data-ntl-acols]');
    var links = [];
    var i;

    /* ---- contents list, built from the real headings ---- */
    if (toc && body) {
      var ul = toc.querySelector('ul');
      var heads = body.querySelectorAll('h2');
      for (i = 0; i < heads.length; i++) {
        var h = heads[i];
        var text = (h.textContent || '').replace(/\s+/g, ' ').trim();
        if (!text) continue;
        if (!h.id) h.id = (root.id || 'ntl-article') + '-h' + (i + 1);
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = text;
        li.appendChild(a);
        if (ul) ul.appendChild(li);
        links.push({ a: a, h: h });
      }
      if (links.length) { toc.hidden = false; } else { toc.hidden = true; }
    }

    /* an empty rail must not hold a 268px column open */
    if (cols && !links.length && cols.getAttribute('data-ntl-rail-shop') !== '1') {
      cols.classList.add('is-norail');
    }

    /* ---- reading progress + active heading ---- */
    if ((bar || links.length) && body) {
      var ticking = false;
      var measure = function () {
        ticking = false;
        var r = body.getBoundingClientRect();
        if (bar) {
          var span = r.height - window.innerHeight;
          var p = span > 0
            ? Math.min(Math.max(-r.top / span, 0), 1)
            : (r.bottom <= window.innerHeight ? 1 : 0);
          bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
        }
        var cur = null;
        for (var j = 0; j < links.length; j++) {
          if (links[j].h.getBoundingClientRect().top < 140) cur = links[j].a;
        }
        for (var k = 0; k < links.length; k++) {
          links[k].a.classList.toggle('on', links[k].a === cur);
        }
      };
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(measure);
      };
      measure();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    }

    /* ---- share: native sheet where there is one, a real copy otherwise ---- */
    var share = root.querySelector('[data-ntl-share]');
    if (share) {
      var live = root.querySelector('[data-ntl-share-live]');
      var icon = share.querySelector('i');
      var canShare = !!(navigator && navigator.share);
      if (canShare) {
        share.setAttribute('aria-label', share.getAttribute('data-ntl-share-label') || 'Share');
      }
      share.addEventListener('click', function () {
        var url = share.getAttribute('data-ntl-share-url') || window.location.href;
        var title = share.getAttribute('data-ntl-share-title') || document.title;
        var msg = share.getAttribute('data-ntl-copied') || 'Link copied';

        function announce() {
          if (icon) {
            icon.className = 'fa-solid fa-check';
            window.setTimeout(function () { icon.className = 'fa-solid fa-link'; }, 1600);
          }
          if (live) live.textContent = msg;
          if (window.NTL && window.NTL.toast) window.NTL.toast(msg);
        }
        function legacyCopy() {
          try {
            var t = document.createElement('textarea');
            t.value = url;
            t.setAttribute('readonly', '');
            t.style.position = 'fixed';
            t.style.top = '-1000px';
            document.body.appendChild(t);
            t.select();
            document.execCommand('copy');
            document.body.removeChild(t);
            announce();
          } catch (e) {
            if (window.NTL && window.NTL.toast) window.NTL.toast('Could not copy the link', 'err');
          }
        }

        if (navigator.share) {
          navigator.share({ title: title, url: url })["catch"](function () {});
          return;
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(announce, legacyCopy);
          return;
        }
        legacyCopy();
      });
    }
  }

  function boot() {
    var roots = document.querySelectorAll('.ntl-article-main');
    for (var i = 0; i < roots.length; i++) {
      try { build(roots[i]); } catch (e) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ntl-cart-main"] && !Shopify.designMode) return;
  try {
    
/* Section-local ONLY (§5.6 — every lookup existence-guarded, one throw would
   kill every later section's JS). Nothing here duplicates ntl-common.js:
   the qty stepper, the undo toast, the recommendations fetch, the add-to-cart
   and the note save are all its delegated handlers. What lives here is the
   three things only the cart PAGE needs. */
(function () {
  'use strict';

  var PAGE = '[data-ntl-cart-page]';
  var SECTIONS = ['cart-count-badge', 'offcanvas-cart'];
  function page() { return document.querySelector(PAGE); }
  function addUrl() {
    return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.cart_add_url : '/cart/add') + '.js';
  }
  var quietDrawerUntil = 0;

  /* ── 1) Section Rendering for the PAGE ────────────────────────────────
     The theme's reloadCartElements() replaces EVERY `.cart-container` with the
     DRAWER's markup — on the cart page that would swap the page layout out from
     under the shopper. Patch the custom element so the drawer stays the drawer
     and the page re-renders from its own section: totals, the progress bar and
     every discount stay server-truth, never JS math. */
  function patchEngine() {
    if (!window.customElements || !customElements.whenDefined) return;
    customElements.whenDefined('cart-container').then(function () {
      var C = customElements.get('cart-container');
      if (!C || !C.prototype || C.prototype.ntlCartPage) return;
      C.prototype.ntlCartPage = true;

      C.prototype.reloadCartElements = function (sections) {
        sections = sections || {};

        if (sections['cart-count-badge']) {
          var bd = new DOMParser().parseFromString(sections['cart-count-badge'], 'text/html');
          var badge = bd.querySelector('.cart-count-badge');
          if (badge) {
            Array.prototype.forEach.call(document.querySelectorAll('.cart-count-badge'), function (old) {
              old.replaceWith(badge.cloneNode(true));
            });
          }
        }

        if (sections['offcanvas-cart']) {
          var dd = new DOMParser().parseFromString(sections['offcanvas-cart'], 'text/html');
          var fresh = dd.querySelector('cart-container');
          var host = document.querySelector('#offcanvas-cart .cart-container');
          if (fresh && host) host.replaceWith(fresh);
        }

        var root = page();
        if (!root) {
          window.dispatchEvent(new CustomEvent('kt.cart.reloaded'));
          return;
        }
        var id = root.getAttribute('data-ntl-section-id');
        root.setAttribute('aria-busy', 'true');
        fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id), {
          headers: { 'Accept': 'text/html' }
        })
          .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('section')); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var next = doc.querySelector(PAGE);
            var live = page();
            if (next && live) live.replaceWith(next);
          })
          .catch(function () {
            /* keep what is on screen rather than blanking the cart; the shopper
               still has a working page and the next mutation retries. */
            if (window.NTL && NTL.toast) NTL.toast('Could not refresh the bag — reload to see the latest', 'err');
          })
          .then(function () {
            var live = page();
            if (live) live.removeAttribute('aria-busy');
            window.dispatchEvent(new CustomEvent('kt.cart.reloaded'));
          });
      };
    }).catch(function () {});
  }

  /* ── 2) adding from THIS page must not throw the drawer over it ──────── */
  document.addEventListener('submit', function (e) {
    var f = e.target, root = page();
    if (!f || !root || !f.classList || !root.contains(f)) return;
    if (f.classList.contains('ntl-add-form')) quietDrawerUntil = Date.now() + 6000;
  }, true);
  document.addEventListener('show.bs.offcanvas', function (e) {
    if (e.target && e.target.id === 'offcanvas-cart' && Date.now() < quietDrawerUntil) {
      if (e.preventDefault) e.preventDefault();
    }
  });

  /* ── 3) recommendations skeletons — revealed ONLY while ntl-common.js has
     not yet claimed the band, so a failed fetch or a no-JS visit can never
     leave a stranded empty rail. */
  function revealSkeletons() {
    var root = page();
    if (!root) return;
    var host = root.querySelector('[data-ntl-recs]');
    if (!host || host.dataset.ntlSkel === '1') return;
    if (!root.querySelector('[data-ntl-line]')) return;
    /* skeletons still in the rail == ntl-common.js has not filled it yet.
       Once it does, its innerHTML swap removes them; if it fails it sets
       hidden itself, and the watchdog below is the last line of defence. */
    if (!host.querySelector('.ntl-cm-skel')) return;
    host.dataset.ntlSkel = '1';
    host.hidden = false;
    setTimeout(function () {
      if (host.querySelector('.ntl-cm-skel')) host.hidden = true;
    }, 8000);
  }

  /* ── 4) FREQUENTLY BOUGHT TOGETHER — one /cart/add.js call for the whole
     bundle, with a per-item retry so a variant that sold out mid-request
     cannot swallow the items that were still available. */
  function fbtInit() {
    var root = page();
    if (!root) return;
    var host = root.querySelector('[data-ntl-fbt]');
    if (!host || host.dataset.ntlFbtOn === '1') return;
    var form = host.querySelector('[data-ntl-fbt-form]');
    var btn = host.querySelector('[data-ntl-fbt-add]');
    var boxes = Array.prototype.slice.call(host.querySelectorAll('[data-ntl-fbt-item]'));
    if (!form || !btn || !boxes.length) return;
    host.dataset.ntlFbtOn = '1';

    var totalEl = host.querySelector('[data-ntl-fbt-total]');
    var saveEl = host.querySelector('[data-ntl-fbt-save]');
    var errEl = host.querySelector('[data-ntl-fbt-err]');
    var labelEl = btn.querySelector('[data-ntl-fbt-label]');

    function sync() {
      var n = 0, sum = 0, cmp = 0;
      boxes.forEach(function (b) {
        if (!b.checked) return;
        n += 1;
        sum += Number(b.getAttribute('data-price') || 0);
        cmp += Number(b.getAttribute('data-compare') || b.getAttribute('data-price') || 0);
      });
      /* this is a PREVIEW of the items' own prices, never the cart total —
         the cart total only ever comes back from the server. */
      if (totalEl && window.NTL && NTL.money) totalEl.textContent = NTL.money(sum);
      if (saveEl) {
        var diff = cmp - sum;
        saveEl.hidden = !(diff > 0);
        if (diff > 0 && window.NTL && NTL.money) {
          saveEl.textContent = (saveEl.getAttribute('data-label') || '') + ' ' + NTL.money(diff);
        }
      }
      btn.disabled = n === 0;
      if (labelEl) {
        var prefix = labelEl.getAttribute('data-prefix') || '';
        var word = n === 1 ? labelEl.getAttribute('data-one') : labelEl.getAttribute('data-many');
        labelEl.textContent = n ? (prefix + ' ' + n + ' ' + (word || '')).trim() : prefix;
      }
    }
    boxes.forEach(function (b) { b.addEventListener('change', sync); });
    sync();

    function post(items) {
      return fetch(addUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items, sections: SECTIONS, sections_url: window.location.pathname })
      }).then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, data: d }; });
      });
    }

    form.addEventListener('submit', function (e) {
      var picked = boxes.filter(function (b) { return b.checked; });
      if (!picked.length) return;
      e.preventDefault();
      if (btn.dataset.busy === '1') return;
      btn.dataset.busy = '1';
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      if (errEl) errEl.hidden = true;
      quietDrawerUntil = Date.now() + 6000;

      var wanted = picked.map(function (b) {
        return { id: Number(b.value), quantity: 1, title: b.getAttribute('data-title') || '' };
      });
      var payload = wanted.map(function (i) { return { id: i.id, quantity: i.quantity }; });

      post(payload)
        .then(function (res) {
          if (res.ok) return { sections: res.data.sections, failed: [] };
          /* partial failure: add what still can be added, name what cannot */
          var failed = [], sections = null;
          return wanted.reduce(function (chain, item) {
            return chain.then(function () {
              return post([{ id: item.id, quantity: item.quantity }]).then(function (one) {
                if (one.ok) sections = one.data.sections;
                else failed.push(item.title || ('#' + item.id));
              });
            });
          }, Promise.resolve()).then(function () {
            return { sections: sections, failed: failed };
          });
        })
        .then(function (out) {
          if (out.sections) {
            if (out.failed.length && window.NTL && NTL.toast) {
              NTL.toast('Added — but ' + out.failed.join(', ') + ' is no longer available', 'err');
            }
            var c = document.querySelector('cart-container');
            if (c && c.reloadCartElements) c.reloadCartElements(out.sections);
            return;
          }
          /* nothing landed — keep the page as it is and say exactly why */
          if (errEl) {
            var p = errEl.querySelector('p');
            if (p) p.textContent = 'Could not add ' + out.failed.join(', ') + '. It may have just sold out.';
            errEl.hidden = false;
          }
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          btn.dataset.busy = '0';
        })
        .catch(function () {
          if (errEl) {
            var p2 = errEl.querySelector('p');
            if (p2) p2.textContent = 'We could not reach the store. Check your connection and try again.';
            errEl.hidden = false;
          }
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          btn.dataset.busy = '0';
        });
    });
  }

  /* ── 5) the mobile checkout bar — shown only while the summary's own CTA
     is off screen. No duplicate control: it submits the same cart form. */
  function barInit() {
    var root = page();
    if (!root || !window.matchMedia || !('IntersectionObserver' in window)) return;
    var bar = root.querySelector('[data-ntl-cart-bar]');
    var anchor = root.querySelector('.ntl-cm-go-wrap');
    if (!bar || !anchor || bar.dataset.ntlBarOn === '1') return;
    bar.dataset.ntlBarOn = '1';

    var mq = window.matchMedia('(max-width:900px)');
    var io = null;
    function watch() {
      if (io) return;
      bar.hidden = false;
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { bar.classList.toggle('is-on', !en.isIntersecting); });
      }, { rootMargin: '0px 0px -12px 0px' });
      io.observe(anchor);
    }
    function drop() {
      if (!io) return;
      io.disconnect();
      io = null;
      bar.classList.remove('is-on');
      bar.hidden = true;
    }
    /* bind once and follow the breakpoint BOTH ways — a window dragged down to
       mobile has to get the bar, not just a page that loaded there. */
    function apply() { if (mq.matches) { watch(); } else { drop(); } }
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
    apply();
  }

  function boot() {
    if (!page()) return;
    patchEngine();
    revealSkeletons();
    fbtInit();
    barInit();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('kt.cart.reloaded', function () { setTimeout(boot, 0); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ntl-collection-grid"] && !Shopify.designMode) return;
  try {
    
/* NTL collection grid — progressive enhancement ONLY.
   With JS off the GET form navigates and every filter, sort, chip and page link
   still works. With JS on the same URLs are fetched through the Section
   Rendering API and swapped in, with pushState, a skeleton and focus restored.
   Every lookup is existence-guarded (§5.6): one throw must not kill the page. */
(function () {
  'use strict';

  function slice(list) { return Array.prototype.slice.call(list || []); }

  function init(root) {
    if (!root || root.getAttribute('data-ntl-cg-ready')) return;
    var swap = root.querySelector('[data-ntl-cg-swap]');
    if (!swap || !swap.id) return;
    root.setAttribute('data-ntl-cg-ready', '1');

    var swapId = swap.id;
    var sid = root.getAttribute('data-ntl-cg-id') || '';
    var desk = window.matchMedia('(min-width:901px)');
    var busy = false;

    function form() { return root.querySelector('[data-ntl-cg-form]'); }
    function side() { return root.querySelector('[data-ntl-cg-side]'); }
    function sheetOpen() {
      var el = side();
      return !!(el && el.classList.contains('on'));
    }

    /* the rail is a plain landmark on desktop — never leave it aria-hidden */
    function fixAria() {
      var el = side();
      if (el && !root.classList.contains('is-fl-drawer') && desk.matches) {
        el.removeAttribute('aria-hidden');
      }
    }

    function buildUrl() {
      var f = form();
      if (!f || typeof FormData !== 'function') return null;
      var parts = [];
      new FormData(f).forEach(function (v, k) {
        var val = String(v == null ? '' : v).trim();
        if (val === '') return;
        parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(val));
      });
      var action = f.getAttribute('action') || window.location.pathname;
      return action + (parts.length ? '?' + parts.join('&') : '');
    }

    function skeleton(on) {
      var main = root.querySelector('[data-ntl-cg-main]');
      var sk = root.querySelector('[data-ntl-cg-skel]');
      if (main) {
        main.classList.toggle('is-busy', !!on);
        main.setAttribute('aria-busy', on ? 'true' : 'false');
      }
      if (sk) sk.hidden = !on;
    }

    function go(url, push) {
      if (!url || busy) return;
      if (!window.fetch || !window.DOMParser) { window.location.href = url; return; }
      busy = true;
      skeleton(true);

      var ae = document.activeElement;
      var focusId = ae && ae.id ? ae.id : null;
      var caret = null;
      try { if (ae && typeof ae.selectionStart === 'number') caret = ae.selectionStart; } catch (e) {}

      var sep = url.indexOf('?') > -1 ? '&' : '?';
      fetch(url + sep + 'section_id=' + encodeURIComponent(sid), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin'
      })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById(swapId);
          var cur = document.getElementById(swapId);
          if (!fresh || !cur) {
            /* clear the busy latch BEFORE handing off: if the navigation is
               blocked or slow, the grid must not be left frozen behind a
               skeleton that nothing will ever take down. */
            busy = false;
            skeleton(false);
            window.location.href = url;
            return;
          }

          cur.innerHTML = fresh.innerHTML;
          if (push) { try { history.pushState({ ntlCg: 1 }, '', url); } catch (e) {} }

          busy = false;
          skeleton(false);
          fixAria();
          if (window.NTL && typeof window.NTL.initAll === 'function') window.NTL.initAll();
          /* A public hook: anything outside this section that mirrors collection
             state can listen for it rather than poll. The banner's category tabs
             used to be the one consumer; they are gone, but the event stays
             because it is the only signal a swap even happened — the URL changes
             through pushState, which fires nothing. */
          try {
            window.dispatchEvent(new CustomEvent('ntl:collection:updated', { detail: { url: url } }));
          } catch (e5) {}

          var back = focusId ? document.getElementById(focusId) : null;
          if (back && back.focus) {
            try { back.focus({ preventScroll: true }); } catch (e) { try { back.focus(); } catch (e2) {} }
            if (caret !== null && back.setSelectionRange) {
              try { back.setSelectionRange(caret, caret); } catch (e3) {}
            }
          } else {
            /* a chip / page link was clicked — put focus on the fresh results */
            var main = root.querySelector('[data-ntl-cg-main]');
            if (main && main.focus) { try { main.focus(); } catch (e4) {} }
          }
        })
        .catch(function () {
          busy = false;
          skeleton(false);
          window.location.href = url;
        });
    }

    /* a facet changed — desktop applies straight away, the sheet waits for
       "Show results" so the page never re-renders behind an open panel */
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.closest || !t.closest('[data-ntl-cg-form]')) return;
      if (sheetOpen()) return;
      go(buildUrl(), true);
    });

    root.addEventListener('submit', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('[data-ntl-cg-form]')) return;
      e.preventDefault();
      var url = buildUrl();
      if (sheetOpen() && window.NTL && typeof window.NTL.closePanel === 'function') {
        window.NTL.closePanel();
      }
      go(url, true);
    });

    /* chips, "clear all", sort-sheet options and every pagination link */
    root.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var a = e.target.closest('[data-ntl-cg-link], .ntl-pag a[href]');
      if (!a || !root.contains(a)) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      e.preventDefault();
      go(href, true);
    });

    window.addEventListener('popstate', function () {
      if (!document.getElementById(swapId)) return;
      go(window.location.href, false);
    });

    if (desk.addEventListener) desk.addEventListener('change', fixAria);
    else if (desk.addListener) desk.addListener(fixAria);
    fixAria();

    /* ── Show more ─────────────────────────────────────────────────────────
       Fetches the next page and appends its cards. The button then takes the
       NEXT page's url from the response, so it walks the whole collection one
       page at a time without the section needing to know how many there are.
       Filtering or sorting re-renders the section, which re-runs boot() and
       gives us a fresh button pointing at page 2 of the new result set. */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ntl-cg-more]');
      if (!btn || !root.contains(btn) || btn.disabled) return;
      var url = btn.getAttribute('data-ntl-cg-more-url');
      var grid = root.querySelector('[data-ntl-cg-grid]');
      if (!url || !grid) return;
      btn.disabled = true;
      btn.textContent = btn.getAttribute('data-ntl-cg-more-busy') || 'Loading…';
      fetch(url, { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('more ' + r.status)); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-ntl-cg-grid]');
          if (!next) throw new Error('no grid in the response');
          var added = 0;
          slice(next.children).forEach(function (card) { grid.appendChild(card); added++; });
          /* the counter is the shopper's only sense of progress */
          var shown = root.querySelector('[data-ntl-cg-shown]');
          if (shown) shown.textContent = String(grid.children.length);
          var nb = doc.querySelector('[data-ntl-cg-more]');
          if (nb && nb.getAttribute('data-ntl-cg-more-url')) {
            btn.setAttribute('data-ntl-cg-more-url', nb.getAttribute('data-ntl-cg-more-url'));
            btn.disabled = false;
            btn.textContent = btn.getAttribute('data-ntl-cg-more-label') || 'Show more';
          } else {
            var w = btn.parentElement;
            if (w) w.remove(); else btn.remove();
          }
          /* reveal animations and lazy media on the new cards */
          if (window.NTL && NTL.initAll) NTL.initAll();
          if (added && window.history && history.replaceState) {
            try { history.replaceState(history.state, '', url); } catch (err) {}
          }
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = btn.getAttribute('data-ntl-cg-more-label') || 'Show more';
        });
    });
  }

  function boot() {
    slice(document.querySelectorAll('[data-ntl-cg]')).forEach(function (el) {
      try { init(el); } catch (e) {}
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ntl-header"] && !Shopify.designMode) return;
  try {
    
/* Section-local ONLY: the two settings that live on #header-group, which no
   delegation in ntl-common.js can reach. Every lookup is existence-guarded
   (§5.6 — one throw kills every later section's JS). */
(function () {
  function boot() {
    var hdr = document.querySelector('.ntl-hdr[data-ntl-header]');
    if (!hdr) return;
    var wrap = hdr.parentElement;
    if (!wrap) return;
    var group = wrap;
    while (group && group.id !== 'header-group') { group = group.parentElement; }
    if (!group) return;

    if (hdr.getAttribute('data-ntl-sticky') === 'false') {
      group.style.position = 'static';
    } else {
      group.style.position = '';
    }

    if (hdr.getAttribute('data-ntl-anno') === 'below' && wrap !== group) {
      group.style.display = 'flex';
      group.style.flexDirection = 'column';
      wrap.style.order = '-1';
    } else if (wrap !== group) {
      wrap.style.order = '';
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);

  /* Theme editor only: reveal the panel a selected block actually lives in,
     otherwise mega and drawer blocks are impossible to edit. */
  function megaBtn() { return document.querySelector('[data-ntl-mega-btn="#ntl-mega"]'); }
  document.addEventListener('shopify:block:select', function (e) {
    if (!e || !e.target) return;
    var mega = document.getElementById('ntl-mega');
    if (mega && mega.contains(e.target)) {
      mega.hidden = false;
      mega.classList.add('on');
      var b = megaBtn();
      if (b) b.setAttribute('aria-expanded', 'true');
      return;
    }
    var drawer = document.getElementById('ntl-mnav');
    if (drawer && drawer.contains(e.target) && window.NTL && window.NTL.openPanel) {
      window.NTL.openPanel(drawer);
    }
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    if (!e || !e.target) return;
    var mega = document.getElementById('ntl-mega');
    if (mega && mega.contains(e.target)) {
      mega.classList.remove('on');
      /* the hidden attribute has to go back on too, or the panel stays in the
         tab order and the accessibility tree for the rest of the editor session */
      setTimeout(function () {
        if (!mega.classList.contains('on')) mega.hidden = true;
      }, 300);
      var b = megaBtn();
      if (b) b.setAttribute('aria-expanded', 'false');
    }
    var drawer = document.getElementById('ntl-mnav');
    if (drawer && drawer.contains(e.target) && window.NTL && window.NTL.closePanel) {
      window.NTL.closePanel();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ntl-product-reviews"] && !Shopify.designMode) return;
  try {
    
/* ============================================================================
   NTL — PRODUCT REVIEWS. Section-local behaviour ONLY: filter, sort, load-more
   and the lightbox stage. Reveal, the average count-up, the distribution bar
   fill, the strip's arrows/drag, and the lightbox's focus trap / ESC / scroll
   lock all come from ntl-common.js by delegation and are not re-implemented.
   Every init is existence-guarded and wrapped: one throw must never take the
   next section's JS down with it.
   ========================================================================= */
(function () {
  'use strict';

  function nodes(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }
  function num(el, attr) {
    var v = parseFloat(el.getAttribute(attr));
    return isNaN(v) ? 0 : v;
  }

  /* ── list: filter + sort + progressive reveal ───────────────────────── */
  function wireList(root) {
    var grid = root.querySelector('[data-rv-grid]');
    if (!grid) return;
    var cards = nodes(grid, '[data-rv-card]');
    if (!cards.length) return;

    var tools   = root.querySelector('[data-rv-tools]');
    var chips   = nodes(root, '[data-rv-chip]');
    var sortSel = root.querySelector('[data-rv-sort]');
    var empty   = root.querySelector('[data-rv-empty]');
    var moreBox = root.querySelector('[data-rv-more]');
    var moreBtn = root.querySelector('[data-rv-more-btn]');
    var moreN   = root.querySelector('[data-rv-more-n]');
    var live    = root.querySelector('[data-rv-live]');
    var clearBt = root.querySelector('[data-rv-clear]');

    var step  = parseInt(root.getAttribute('data-rv-step'), 10) || 6;
    var shown = step;
    var kind  = 'all';
    var value = '';
    var sort  = sortSel ? sortSel.value : 'featured';

    function matches(c) {
      if (kind === 'rating') return String(num(c, 'data-rv-r')) === value;
      if (kind === 'photos') return c.getAttribute('data-rv-p') === '1';
      if (kind === 'topic')  return (c.getAttribute('data-rv-t') || '') === value;
      return true;
    }
    function byIndex(a, b) { return num(a, 'data-rv-i') - num(b, 'data-rv-i'); }
    function ordered(list) {
      var out = list.slice();
      if (sort === 'rating_desc') {
        out.sort(function (a, b) { return (num(b, 'data-rv-r') - num(a, 'data-rv-r')) || byIndex(a, b); });
      } else if (sort === 'rating_asc') {
        out.sort(function (a, b) { return (num(a, 'data-rv-r') - num(b, 'data-rv-r')) || byIndex(a, b); });
      } else if (sort === 'helpful') {
        out.sort(function (a, b) { return (num(b, 'data-rv-h') - num(a, 'data-rv-h')) || byIndex(a, b); });
      } else if (sort === 'photos') {
        out.sort(function (a, b) {
          var pa = a.getAttribute('data-rv-p') === '1' ? 1 : 0;
          var pb = b.getAttribute('data-rv-p') === '1' ? 1 : 0;
          return (pb - pa) || byIndex(a, b);
        });
      }
      return out;
    }

    function apply(focusAt) {
      var list = ordered(cards.filter(matches));
      var i;
      for (i = 0; i < cards.length; i++) cards[i].hidden = true;
      for (i = 0; i < list.length; i++) {
        grid.appendChild(list[i]);
        list[i].hidden = i >= shown;
      }
      var vis = Math.min(shown, list.length);
      if (empty)   empty.hidden = list.length > 0;
      if (moreBox) moreBox.hidden = list.length <= shown;
      if (moreN)   moreN.textContent = list.length > shown ? '(' + (list.length - shown) + ')' : '';
      if (live)    live.textContent = 'Showing ' + vis + ' of ' + list.length + ' reviews';
      if (typeof focusAt === 'number' && list[focusAt]) {
        try { list[focusAt].focus(); } catch (e) {}
      }
    }

    function paint() {
      for (var i = 0; i < chips.length; i++) {
        var c = chips[i];
        var on = (c.getAttribute('data-rv-kind') || 'all') === kind &&
                 (c.getAttribute('data-rv-value') || '') === value;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    }

    chips.forEach(function (b) {
      b.disabled = false;
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-rv-kind') || 'all';
        var v = b.getAttribute('data-rv-value') || '';
        if (k !== 'all' && k === kind && v === value) { k = 'all'; v = ''; }
        kind = k; value = v; shown = step;
        paint();
        apply();
      });
    });

    if (sortSel) {
      sortSel.disabled = false;
      sortSel.addEventListener('change', function () {
        sort = sortSel.value; shown = step; apply();
      });
    }
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        var from = shown;
        shown += step;
        apply(from);
      });
    }
    if (clearBt) {
      clearBt.addEventListener('click', function () {
        kind = 'all'; value = ''; shown = step; paint(); apply();
      });
    }

    /* the theme editor selecting a review block must never leave it clamped */
    root._ntlRvShowAll = function () {
      kind = 'all'; value = ''; shown = cards.length; paint(); apply();
    };

    if (tools) tools.classList.add('is-ready');
    apply();
  }

  /* ── lightbox: stage + prev/next. Open/close/trap is ntl-common.js. ──── */
  function wireLightbox(root) {
    var lb = root.querySelector('[data-rv-lb]');
    if (!lb) return;
    var stage = lb.querySelector('[data-rv-stage]');
    if (!stage) return;
    var cap  = lb.querySelector('[data-rv-capout]');
    var prev = lb.querySelector('[data-rv-prev]');
    var next = lb.querySelector('[data-rv-next]');

    var img = document.createElement('img');
    img.setAttribute('width', '1200');
    img.setAttribute('height', '1200');
    img.setAttribute('decoding', 'async');
    img.alt = '';
    stage.appendChild(img);

    var set = [], at = 0;

    function show(i) {
      if (!set.length) return;
      at = (i + set.length) % set.length;
      var b = set[at];
      var thumbEl = b.querySelector('img');
      var thumb = thumbEl ? (thumbEl.currentSrc || thumbEl.src) : '';
      var full = b.getAttribute('data-rv-full') || thumb;
      img.onerror = function () { img.onerror = null; if (thumb) img.src = thumb; };
      img.setAttribute('width', b.getAttribute('data-rv-w') || '1200');
      img.setAttribute('height', b.getAttribute('data-rv-h') || '1200');
      img.alt = b.getAttribute('data-rv-alt') || '';
      img.src = full || '';
      if (cap) {
        var who = b.getAttribute('data-rv-cap') || '';
        cap.textContent = set.length > 1 ? who + ' · ' + (at + 1) + ' / ' + set.length : who;
      }
      if (prev) prev.hidden = set.length < 2;
      if (next) next.hidden = set.length < 2;
    }

    function open(items, i) {
      set = items;
      show(i);
      if (window.NTL && window.NTL.openPanel) window.NTL.openPanel(lb);
      else lb.classList.add('on');
    }

    root.addEventListener('click', function (e) {
      if (e.defaultPrevented) return;               /* a rail drag, not a click */
      if (!e.target || !e.target.closest) return;
      var b = e.target.closest('[data-rv-ph]');
      if (!b || !root.contains(b)) return;
      var box = b.closest('[data-rv-set]');
      var items = box ? nodes(box, '[data-rv-ph]') : [b];
      var at0 = items.indexOf(b);
      open(items, at0 < 0 ? 0 : at0);
    });

    if (prev) prev.addEventListener('click', function () { show(at - 1); });
    if (next) next.addEventListener('click', function () { show(at + 1); });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); show(at - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(at + 1); }
    });
  }

  function setup(root) {
    /* JS now owns visibility: drop the no-JS clamp FIRST, so any later throw
       can only ever leave more content on screen, never less. */
    var cards = nodes(root, '[data-rv-card]');
    for (var i = 0; i < cards.length; i++) {
      cards[i].removeAttribute('data-rv-over');
      cards[i].setAttribute('tabindex', '-1');
    }
    try { wireList(root); } catch (e) {}
    try { wireLightbox(root); } catch (e) {}
  }

  function init(scope) {
    var host = scope && scope.querySelectorAll ? scope : document;
    var roots = nodes(host, '[data-ntl-reviews]');
    if (host.matches && host.matches('[data-ntl-reviews]')) roots.push(host);
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (root.getAttribute('data-rv-ready')) continue;
      root.setAttribute('data-rv-ready', '1');
      setup(root);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    if (!e.target || !e.target.closest) return;
    var root = e.target.closest('[data-ntl-reviews]');
    if (root && typeof root._ntlRvShowAll === 'function') root._ntlRvShowAll();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ntl-product-set"] && !Shopify.designMode) return;
  try {
    
/* Section-local ONLY: the add-BOTH control. ntl-common.js owns `.ntl-add-form`
   (one variant, FormData); a set is one POST carrying an `items` array, which
   no shared handler models — so it lives here. Everything else (drawer, count
   sync, toast, Section Rendering) is reused from window.NTL.
   Registered once by delegation, and every lookup is existence-guarded
   (§5.6 — one throw kills every later section's JS). */
(function () {
  if (window.__ntlSetBound) return;
  window.__ntlSetBound = true;

  var SECTIONS = ['cart-count-badge', 'offcanvas-cart'];

  function payload(form) {
    var out = [];
    var nodes = form.querySelectorAll('[data-ntl-set-id]');
    for (var i = 0; i < nodes.length; i++) {
      var id = Number(nodes[i].value);
      if (!id) continue;
      var q = Number(nodes[i].getAttribute('data-ntl-set-qty')) || 1;
      out.push({ id: id, quantity: q });
    }
    return out;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('form.ntl-set-form') : null;
    if (!form) return;

    var items = payload(form);
    if (!items.length) return;               /* let the native POST through */
    if (form.dataset.ntlBusy === '1') { e.preventDefault(); return; }
    e.preventDefault();
    form.dataset.ntlBusy = '1';

    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }

    var url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_add_url)
      ? window.Shopify.routes.cart_add_url : '/cart/add';

    fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: SECTIONS.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          throw new Error((res.data && (res.data.description || res.data.message)) || 'Could not add the set');
        }
        var c = document.querySelector('cart-container');
        if (c && res.data.sections && typeof c.reloadCartElements === 'function') {
          c.reloadCartElements(res.data.sections);
        }
        window.dispatchEvent(new CustomEvent('kt.cart.added', { detail: res.data }));
        if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-ok'); }
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (window.NTL && window.NTL.syncCartCounts) window.NTL.syncCartCounts(cart.item_count);
          })
          .catch(function () {});
      })
      .then(function () {
        if (window.NTL && window.NTL.openCartDrawer) window.NTL.openCartDrawer();
      })
      .catch(function (err) {
        if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-err'); }
        if (window.NTL && window.NTL.toast) window.NTL.toast(err.message || 'Could not add the set', 'err');
      })
      .then(function () {
        setTimeout(function () {
          form.dataset.ntlBusy = '0';
          if (btn) {
            btn.classList.remove('is-loading', 'is-ok', 'is-err');
            btn.removeAttribute('aria-busy');
            btn.disabled = false;
          }
        }, 1200);
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ntl-shop-the-look"] && !Shopify.designMode) return;
  try {
    
/* Section-local ONLY: FourSixty injects its tiles asynchronously, long after
   ntl-common.js has synced the rail arrows. Re-sync once the feed lands.
   Everything else (arrow clicks, disabled state, drag, reveal) is ntl-common. */
(function () {
  try {
    if (typeof window === 'undefined' || !window.MutationObserver) return;

    function watch(rail) {
      if (!rail || rail.getAttribute('data-ntl-stl-watch') === '1') return;
      rail.setAttribute('data-ntl-stl-watch', '1');
      var t = null;
      var mo = new MutationObserver(function () {
        if (t) clearTimeout(t);
        t = setTimeout(function () {
          if (window.NTL && typeof window.NTL.syncRail === 'function') window.NTL.syncRail(rail);
        }, 150);
      });
      mo.observe(rail, { childList: true, subtree: true });
    }

    function initAll() {
      var els = document.querySelectorAll('.ntl-shop-the-look [data-ntl-stl-feed]');
      for (var i = 0; i < els.length; i++) watch(els[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  } catch (e) {}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ntl-sticky-atc"] && !Shopify.designMode) return;
  try {
    
/* Section-local ONLY. The AJAX add lives in ntl-common.js (`form.ntl-add-form`);
   what cannot be delegated is (a) the IntersectionObserver that reveals the bar
   and (b) mirroring the buy box's variant id, price and availability into it.
   Every lookup is existence-guarded (§5.6 — one throw kills every later
   section's JS) and the class flip is rAF-throttled. */
(function () {
  function boot() {
    var bars = document.querySelectorAll('.ntl-sticky-atc[data-ntl-sbar]');
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      if (bar.getAttribute('data-ntl-sbar-ready') === '1') continue;
      bar.setAttribute('data-ntl-sbar-ready', '1');
      try { init(bar); } catch (e) { /* never take the page's JS down with us */ }
    }
  }

  function init(bar) {
    var map = {};
    try { map = JSON.parse(bar.getAttribute('data-ntl-sbar-v') || '{}'); } catch (e) { map = {}; }

    var priceEl = bar.querySelector('[data-ntl-sbar-price]');
    var idEl = bar.querySelector('[data-ntl-sbar-id]');
    var qtyEl = bar.querySelector('[data-ntl-sbar-qty]');
    var btn = bar.querySelector('[data-ntl-sbar-btn]');
    /* re-queried every time: the shared add-to-cart handler restores the
       button's innerHTML after a successful add, which replaces this node —
       a cached reference would silently go stale after the first add */
    function labelEl() { return bar.querySelector('[data-ntl-sbar-label]'); }
    var addTxt = bar.getAttribute('data-ntl-sbar-add') || 'Add to cart';
    var outTxt = bar.getAttribute('data-ntl-sbar-out') || 'Sold out';
    /* borrowed from the buy box so the two bars never disagree on wording */
    var naTxt = (function () {
      var pb = document.querySelector('.ntl-pfold .pbuy');
      return (pb && pb.getAttribute('data-pf-labels-unavailable')) || outTxt;
    })();

    /* ---- find the buy box: the section's selector, then the theme's own --- */
    function pick(list) {
      for (var i = 0; i < list.length; i++) {
        if (!list[i]) continue;
        var hits;
        try { hits = document.querySelectorAll(list[i]); } catch (e) { hits = []; }
        /* every match, not just the first: the first `form[action*=/cart/add]`
           on the page can be this bar's own form */
        for (var j = 0; j < hits.length; j++) {
          if (!bar.contains(hits[j])) return hits[j];
        }
      }
      return null;
    }

    var mainForm = pick([
      bar.getAttribute('data-ntl-sbar-form'),
      '.ntl-pfold form.ntl-add-form',
      '[data-ntl-buybox] form[action*="/cart/add"]',
      'product-form form[action*="/cart/add"]',
      'form[action*="/cart/add"]'
    ]);
    /* the buy box's own rendered price, when there is one: mirroring it keeps
       compare-at, unit price and any theme decoration in step for free */
    var priceSrc = pick([
      bar.getAttribute('data-ntl-sbar-price-src'),
      '.ntl-pfold [data-pf-price]',
      '.ntl-pfold .pdp-price'
    ]);
    var mainId = mainForm ? mainForm.querySelector('[name="id"]') : null;
    var mainQty = mainForm ? mainForm.querySelector('[name="quantity"]') : null;

    /* ---- keep the two forms carrying the SAME variant --------------------- */
    function sync() {
      /* `|| ''` is the point: the buy box BLANKS this input when the chosen option
         combination matches no variant. Treating blank as "nothing to mirror" left
         this bar holding the previously selected variant and still enabled, so a
         shopper who scrolled past an "Unavailable" buy box could add a variant they
         never chose. Not reachable on today's catalogue — every multi-value option is
         paired only with single-value ones — but it would be the day a second
         multi-value option is added. */
      if (mainId && idEl) idEl.value = String(mainId.value || '');
      if (mainQty && qtyEl) {
        var q = parseInt(mainQty.value, 10);
        if (q > 0) qtyEl.value = String(q);
      }
      if (priceEl && priceSrc && priceSrc.innerHTML) {
        if (priceEl.innerHTML !== priceSrc.innerHTML) priceEl.innerHTML = priceSrc.innerHTML;
      }
      var v = idEl && idEl.value ? map[String(idEl.value)] : null;
      if (!v) {
        if (btn && !btn.classList.contains('is-loading')) {
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
          var lbNa = labelEl();
          if (lbNa) lbNa.textContent = naTxt;
        }
        return;
      }
      if (priceEl && !priceSrc && window.NTL && typeof window.NTL.money === 'function') {
        priceEl.textContent = window.NTL.money(v.p);
      }
      if (btn) {
        var out = v.a === false;
        /* never fight the shared handler's loading state */
        if (!btn.classList.contains('is-loading')) {
          btn.disabled = out;
          if (out) { btn.setAttribute('aria-disabled', 'true'); }
          else { btn.removeAttribute('aria-disabled'); }
          var lb = labelEl();
          if (lb) lb.textContent = out ? outTxt : addTxt;
        }
      }
    }

    if (mainId) {
      document.addEventListener('change', function (e) {
        if (e.target === mainId || (mainForm && mainForm.contains(e.target))) sync();
      }, true);
      document.addEventListener('input', function (e) {
        if (e.target === mainId || (mainForm && mainForm.contains(e.target))) sync();
      }, true);
      if (window.MutationObserver) {
        new MutationObserver(sync).observe(mainId, { attributes: true, attributeFilter: ['value'] });
      }
      /* a picker that assigns `input.value` (the property) and fires nothing
         moves neither listener nor observer — re-read just after the click */
      document.addEventListener('click', function (e) {
        if (!mainForm || !mainForm.contains(e.target)) return;
        setTimeout(sync, 0);
        setTimeout(sync, 150);
      }, true);
    }
    ['variant:change', 'variantChange', 'kt.variant.changed', 'kt.cart.reloaded'].forEach(function (ev) {
      document.addEventListener(ev, sync);
      window.addEventListener(ev, sync);
    });
    sync();

    /* ---- reveal once the buy box has left the viewport -------------------- */
    var target = pick([
      bar.getAttribute('data-ntl-sbar-observe'),
      '.ntl-pfold .fbuy',
      '[data-ntl-buybox]',
      '.fbuy',
      'product-form'
    ]) || mainForm;

    var want = false, queued = false;

    /* Publish the bar's state and its MEASURED height on <html>, so anything else
       pinned to the bottom of the viewport can move out of its way. The WhatsApp
       button sits at bottom:22px and the bar covers the bottom of the screen, so
       the button landed on top of Add to cart the moment the bar slid up.
       A measured height rather than a guess: the bar is taller on desktop than on
       mobile, and its padding carries env(safe-area-inset-bottom) on notched
       phones. Nothing here reaches into another section's DOM — the footer's own
       CSS reacts to the flag. */
    function publish() {
      var root = document.documentElement;
      var h = bar.classList.contains('on') ? Math.round(bar.getBoundingClientRect().height) : 0;
      root.classList.toggle('ntl-sbar-on', h > 0);
      root.style.setProperty('--ntl-sbar-h', h + 'px');
    }

    function apply() {
      queued = false;
      bar.classList.toggle('on', want);
      if (want) sync();   /* never slide up carrying a stale variant */
      publish();
    }
    window.addEventListener('resize', publish);
    document.addEventListener('shopify:section:load', publish);
    function queue() { if (!queued) { queued = true; requestAnimationFrame(apply); } }

    var offset = parseInt(bar.getAttribute('data-ntl-sbar-offset'), 10);
    if (isNaN(offset)) offset = 140;

    /* The bar is fixed across the bottom, so at the foot of the page it covers the
       footer's last row — the copyright, the payment icons and the country picker,
       which a shopper has to be able to click. Standing down once the footer is in
       view costs nothing: someone reading the footer has already scrolled past the
       buy box and is not shopping the bar. */
    var atFooter = false;
    function wants(v) { want = v && !atFooter; }

    if ('IntersectionObserver' in window) {
      var foot = document.querySelector('.ntl-footer, footer');
      if (foot) {
        new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) atFooter = entries[i].isIntersecting;
          if (atFooter) want = false;
          queue();
        }, { threshold: 0 }).observe(foot);
      }
    }

    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) wants(!entries[i].isIntersecting);
        queue();
      }, { rootMargin: '-' + offset + 'px 0px 0px 0px' }).observe(target);
    } else {
      /* no observer, or no buy box on this template: fall back to scroll depth
         so the bar is never stranded off-screen with no way to appear */
      var floor = Math.max(320, offset * 4);
      window.addEventListener('scroll', function () {
        wants((window.pageYOffset || document.documentElement.scrollTop || 0) > floor);
        queue();
      }, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ntl-tracking"] && !Shopify.designMode) return;
  try {
    
/* NTL tracking — the query string, which Liquid cannot see.
   Everything here is enhancement: with the script disabled the form is still a
   working GET and the page still renders its lookup state. */
(function () {
  'use strict';

  function param(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (e) {
      var m = new RegExp('[?&]' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^&#]*)')
        .exec(window.location.search);
      return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : null;
    }
  }

  function init(root) {
    if (!root || root.getAttribute('data-ntl-track-ready')) return;
    root.setAttribute('data-ntl-track-ready', '1');

    var key = root.getAttribute('data-ntl-track-param') || 'id';
    var statusKey = root.getAttribute('data-ntl-track-status') || 'status';
    var ref = (param(key) || '').trim();

    var empty = root.querySelector('[data-ntl-track-empty]');
    var result = root.querySelector('[data-ntl-track-result]');
    var out = root.querySelector('[data-ntl-track-ref]');

    if (ref) {
      if (out) out.textContent = ref;
      if (result) result.hidden = false;
      if (empty) empty.hidden = true;

      var tpl = root.getAttribute('data-ntl-track-carrier');
      var link = root.querySelector('[data-ntl-track-carrier-link]');
      if (link) {
        if (tpl) link.setAttribute('href', tpl.split('{ref}').join(encodeURIComponent(ref)));
        else link.hidden = true;
      }
    }

    /* mark the timeline up to the stage named in ?status= */
    var status = (param(statusKey) || '').trim().toLowerCase();
    if (status) {
      var steps = Array.prototype.slice.call(root.querySelectorAll('[data-ntl-track-step]'));
      var at = -1;
      steps.forEach(function (el, i) {
        if (at === -1 && (el.getAttribute('data-ntl-track-step') || '').toLowerCase() === status) at = i;
      });
      if (at > -1) steps.forEach(function (el, i) {
        el.classList.toggle('is-done', i < at);
        el.classList.toggle('is-now', i === at);
      });
    }

    /* "Use another" puts the form back without a reload */
    var change = root.querySelector('[data-ntl-track-change]');
    if (change) change.addEventListener('click', function () {
      if (result) result.hidden = true;
      if (empty) {
        empty.hidden = false;
        var f = empty.querySelector('input[type="text"]');
        if (f) { f.value = ref; try { f.focus(); } catch (e) {} }
      }
    });

    /* keep every OTHER parameter the page arrived with — a plain GET form drops
       them, and one of them is the ?view= that selects this template */
    var form = root.querySelector('[data-ntl-track-form]');
    if (form) form.addEventListener('submit', function (e) {
      var field = form.querySelector('input[name="' + key + '"]');
      var val = field && field.value ? field.value.trim() : '';
      if (!val || typeof URLSearchParams !== 'function') return;
      e.preventDefault();
      var q = new URLSearchParams(window.location.search);
      q.set(key, val);
      window.location.href = window.location.pathname + '?' + q.toString();
    });
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-ntl-track]'))
      .forEach(function (el) { try { init(el); } catch (e) {} });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
